import { Component, Input, HostListener , AfterViewInit, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Dropdown, Donut  } from '@eds/vanilla';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';

import { DomSanitizer } from '@angular/platform-browser';

import { userUsageDataService } from '../service/userUsage.data.service';
import { deviceUsageDataService } from '../service/deviceUsage.data.service';
import { applicationUsageDataService } from '../service/applicationUsage.data.service';
import { learningContentDataService } from '../service/contentUsage.data.service';

@Component({
  selector: 'app-data-overview-component',
  templateUrl: './data-overview-component.component.html',
  styleUrls: ['./data-overview-component.component.css']
})

export class DataOverviewComponentComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() dataFiltered: any;

  @ViewChild('dropdown', {static: false})
  private dropdownMenu: ElementRef;

  @ViewChild('deviceDropdown', {static: false})
  private deviceDropdownMenu: ElementRef;

  @ViewChild('applicationDropdown', {static: false})
  private appDropdownMenu: ElementRef;

  @ViewChild('contentDropdown', {static: false})
  private contentDropdownMenu: ElementRef;
  overview: any;
  subscription = [];
  isNaN: Function = Number.isNaN;
  studentLoginSum: any;
  teacherLoginSum: any;
  adminLoginSum: any;
  screenHeight: any;
  screenWidth: any;
  ctlStudentAppSum: any;
  internetBrowserSum: any;
  othersSum: any;
  ctlStudentJson: any;
  usertoDeviceAvg: any;
  userOverviewUsageData_new: any;
  deviceOverviewData: any;
  applicationOverviewData: any;
  contentOverviewData: any;

  tabletDeployedSum: any;
  laptopDeployedSum: any;
  tabletUsedSum: any;
  laptopUsedSum: any;
  overviewstudentTabletAgg: any;
  overviewstudentLaptopAgg: any;
  overviewteacherTabletAgg: any;
  overviewteacherLaptopAgg: any;
  overviewadminTabletAgg: any;
  overviewadminLaptopAgg: any;

  studentTabletAgg: any;
  studentLaptopAgg: any;

  teacherTabletAgg: any;
  teacherLaptopAgg: any;

  adminTabletAgg: any;
  adminLaptopAgg: any;
  userData: any;

  items: any;
  userOverviewUsageData = [];
  sumofContentItems: any = [];
  sumofApplicationItems: any = [];
  sumofDeviceItems: any = [];
  nodataApplication:any = [];
  isLessScreenSize = false;
  userPerDevice = 0;
  isDataFiltered: any;
  data_01 = [];

  edsData01: any;
  edsData02: any;
  edsData03: any;
  edsData04: any;
  edsData05: any;

  edsNoData:any;
  isDonutloaded1 = false;
  isDonutloaded2 = false;
  isDonutloaded3 = false;
  isDonutloaded4 = false;
  isDonutloaded5 = false;
  data_01_01 = [];
  // public classReference = DataOverviewComponentComponent;



  settings_01 = {
    selector: 'userActivityOverviewChart',
    width: 260,
    height: 260,
    hole: 120,
    colors : ['#813aa1', '#11c273', '#1a609b'],
    total: 'sum',
    totalText: 'Total Logins'
  };

  data_02_01 = [
    {id: 'Deployed', count: 300},
    {id: 'Used', count: 180}
  ];

  settings_02_01 = {
    selector: 'tabUtilChart',
    width: 203,
    height: 203,
    hole: 90,
    colors : ['#0c9b5b', '#4e4e4e'],
    total: 'percentage',
    totalText: 'Utilization'
  };

  data_02_02 = [
    { id: 'Deployed', count: 300 },
    { id: 'Used', count: 180}
  ];

  settings_02_02 = {
    selector: 'pcUtilChart',
    width: 203,
    height: 203,
    hole: 90,
    colors : ['#a56ebe', '#4e4e4e'],
    total: 'percentage',
    totalText: 'Utilization'
  };
  fontBig = '64px';
  fontSmall = '44px';
  data_03 = [];

  settings_03 = {
    selector: 'applicationOverviewChart',
    width: 203,
    height: 203,
    hole: 90,
    colors : ['#bf93db', '#813aa1', '#3f1f4d'],
    total: 'sum',
    totalText: 'App Use (hours)'
  };

  data_04 = [
    {id: 'Video', count: 300},
    {id: 'Documents', count: 300},
    {id: 'Audio', count: 300},
    {id: 'eLearning Courses', count: 300}
  ];

  settings_04 = {
    selector: 'learningContentChart',
    width: 203,
    height: 203,
    hole: 90,
    colors : ['#613675', '#11c273', '#1a609b', '#819eb7'],
    total: 'sum',
    totalText: 'Learning Items'
  };
  sumofUserItems: any = [];

  fileUrl;
  dashToken: string;
  sub: any;
  countryId: any;
  projectId: any;
  fromDate: any;
 textDir:any;
  constructor(
    private userUsageService: userUsageDataService,
    private deviceUsageService: deviceUsageDataService,
    private applicationUsageService: applicationUsageDataService,
    private contentUsageService: learningContentDataService,
    private sanitizer: DomSanitizer) {
      this.dashToken =  localStorage.getItem('token');
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('light');
      body.classList.add('dark');
      this.textDir = sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    this.loadAllSectionsData();
  }
  
  ngOnDestroy() {
    this.subscription.forEach(sub => {
      sub.unsubscribe();
    });
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('dark');
    body.classList.add('light');
  }
  ngAfterViewInit() {
    this.userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    const dropdownComp = new Dropdown(this.dropdownMenu.nativeElement);
    dropdownComp.init();

    const deviceDropdownComp = new Dropdown(this.deviceDropdownMenu.nativeElement);
    deviceDropdownComp.init();

    const appdropdownComp = new Dropdown(this.appDropdownMenu.nativeElement);
    appdropdownComp.init();

    const contentdropdownComp = new Dropdown(this.contentDropdownMenu.nativeElement);
    contentdropdownComp.init();

    // this.donutChartInit();

  }
  donutChartNodata(){   
    const noChart = new Donut({
      element: document.getElementById('total-donut'),
      data: this.edsNoData,
      showValue: true,
      showAbsoluteValue: true,
      unit: 'No data'
    });
    noChart.init();
  }
  donutChartInit1(){  
    document.getElementById('total-donut').innerHTML = '';
    const chart1 = new Donut({
      element: document.getElementById('total-donut'),
      data: this.edsData01,
      showValue: true,
      showAbsoluteValue: true,
      unit: 'Total logins'
    });
    chart1.init();
  }
  donutChartInit2(){
    document.getElementById('percentage-donut1').innerHTML ="";

    const chart2 = new Donut({
      element: document.getElementById('percentage-donut1'),
      data: this.edsData03,
      showValue: true,
      unit: 'Utilization'
    });
    chart2.init();
  }
  donutChartInit3(){
    document.getElementById('percentage-donut2').innerHTML="";
    const chart3 = new Donut({
      element: document.getElementById('percentage-donut2'),
      data: this.edsData04,
      showValue: true,
      unit: 'Utilization'
    });
 
    chart3.init();
  }
  donutChartInit4(){
    document.getElementById('absolute-donut').innerHTML="";
    const chart4 = new Donut({
      element: document.getElementById('absolute-donut'),
      data: this.edsData02,
      showAbsoluteValue: true,
      showValue: true,
      unit: 'App Use (hours)'
    });
    chart4.init();
  }
  donutChartInit5(){
    document.getElementById('absolute-donut2').innerHTML="";
    const chart5 = new Donut({
      element: document.getElementById('absolute-donut2'),
      data: this.edsData05,
      showAbsoluteValue: true,
      showValue: true,
      unit: 'Learning Items'
    });
    chart5.init();
  }
  loadAllSectionsData() {
    const sub1 = this.userUsageService.userUsage$Data.subscribe(data => {
      // all load data service

      this.userUsageService.getUserActivityOverviewData();
      this.userUsageService.getUserActivityOverviewPerData();

      // all data subscription
      this.getUserActivityOverview();
      
    });
    this.subscription.push(sub1);

    //device
    const sub2 = this.deviceUsageService.deviceUsage$Data.subscribe(data => {
      // all load data service
      this.deviceUsageService.getDeviceOverviewData();
      this.deviceUsageService.getTabletOverviewUtilizationData();
      this.deviceUsageService.getLaptopOverviewUtilizationData();
      this.deviceUsageService.getUserToDeviceAvgData();

      // data subscriptions
      this.getDeviceOverview();
      this.getTabletUtilization();
      this.getLaptopUtilization();
      this.getUserPerDevice();
    
    });
    this.subscription.push(sub2);

    // application
    const sub3 = this.applicationUsageService.applicationUsage$Data.subscribe(data => {
      // load all services
      this.applicationUsageService.getApplicationOverviewData();

      // all data subscription
      this.getApplicationOverview();
      this.getApplicationOverviewTab();
     
    });
    this.subscription.push(sub3);

    // application
    const sub4 = this.contentUsageService.contentUsage$Data.subscribe(data => {
      // load all services
      this.contentUsageService.getContentOverviewData();

      // all data subscription
      this.getContentOverview();
      this.getContentOverviewTab();
      
    });

    this.subscription.push(sub4);
  }

  getUserActivityOverview() {
    if (document.getElementById('total-donut')){
      document.getElementById('total-donut').innerHTML = '';
    }
    const sub1 = this.userUsageService.loginActivity$Data.subscribe(data => {
      this.data_01 = [...data];
     
      // KAJAL
      const edsDataObj = [];
      this.data_01.forEach((a,index) => {
        const dataObj = {name: a.id, values: [a.count], colorID: (index+5).toString()};
        edsDataObj.push(dataObj);
      });
    
      // edsDataObj.push({name: 'test', value: ['300'], colorID: '3'});
      this.edsData01 =[];
      
      const edsEmptyData = [{name: 'Teacher', values: [200], colorID: '2'}];
      if(edsDataObj.length > 0){
        this.edsData01 = {series: edsDataObj};
      }else{      
        this.edsData01 = {series: edsEmptyData};
      }  
      this.donutChartInit1();  
    //  console.log("edsDataObj getUserActivityOverview >>> "+JSON.stringify(this.edsData01))
    });
    
    this.subscription.push(sub1);
  
    const sub2 = this.userUsageService.loginActivityPer$Data.subscribe(data => {
      this.data_01_01 = [...data];
      if(this.data_01_01.length==0){
        this.data_01_01 = [{"role":"Teacher","total":0,"Tablet":0,"Laptop":0},{"role":"Student","total":0,"Tablet":0,"Laptop":0},{"role":"Project Admin","total":0,"Tablet":0,"Laptop":0}];
      }
    });
    this.subscription.push(sub2);
   
  }

  getDeviceOverview() {
    const sub = this.deviceUsageService.deviceOverview$Data.subscribe(data => {
      this.sumofDeviceItems = [...data];
      let filteredDeviceData: any[] = data;
       console.log("sumofDeviceItems >>>>> "+JSON.stringify(this.sumofDeviceItems))
      filteredDeviceData = data.filter(function(item){
              
        // for (let key in item) {
        //   console.log("sumofDeviceItems key  >>>>> "+JSON.stringify(key))
        // }

      });
    });
    this.subscription.push(sub);
    
  }

  getTabletUtilization() {
    const sub = this.deviceUsageService.tabletUtilization$Data.subscribe(data => {
      this.data_02_01 = [...data];
     
      // edsDataObj.push({name: 'test', value: ['300'], colorID: '3'});
      const edsDataObj = [];
    const colorStr = ['1', '11']
    this.data_02_01.forEach((a, index) => {
      const dataObj = {name: a.id, values: [a.count], colorID: (index+1).toString()};
      edsDataObj.push(dataObj);
    });
    this.edsData03 =[];
    this.edsData03 = {series: edsDataObj};
  //console.log("edsDataObj >> "+JSON.stringify(edsDataObj));

   const edsEmptyData = [{name: 'Deployed', values: [200], colorID: '2'}, {name: 'Used', values: [120], colorID: '3'}];
   if(this.data_02_01.length > 0){
     this.edsData03 = {series: edsDataObj};
   }else{
    
    
     this.edsData03 = {series: edsEmptyData};
   }    
   this.donutChartInit2();
    });
   /*  if (document.getElementById('percentage-donut1')){
      document.getElementById('percentage-donut1').innerHTML = '';
    } */
    
    this.subscription.push(sub);
    
  }

  getLaptopUtilization() {
    const sub = this.deviceUsageService.laptopUtilization$Data.subscribe(data => {
      this.data_02_02 = [...data];
      const edsDataObj3 = [];
   
      data.forEach((a, index) => {
        const dataObj = {name: a.id, values: [a.count], colorID: (index+1).toString()};
        edsDataObj3.push(dataObj);
      });
      // edsDataObj.push({name: 'test', value: ['300'], colorID: '3'});
      this.edsData04=[];
      this.edsData04 = {series: edsDataObj3};
      const edsEmptyData = [{name: 'Deployed', values: [200], colorID: '2'}, {name: 'Used', values: [120], colorID: '3'}];
   if(this.data_02_02.length > 0){
     this.edsData04 = {series: edsDataObj3};
   }else{
    
    
     this.edsData04 = {series: edsEmptyData};
   }  
   this.donutChartInit3();
    });
    /* if (document.getElementById('percentage-donut2')){
       document.getElementById('percentage-donut2').innerHTML = '';
    } */
   
    this.subscription.push(sub);
    
  }

  getUserPerDevice() {
    const sub = this.deviceUsageService.userPerDevice$Data.subscribe(data => {
      this.userPerDevice = data;
    });
    this.subscription.push(sub);
  }

  getApplicationOverview() {
    const sub = this.applicationUsageService.applicationOverview$Data.subscribe(data => {
      this.data_03 = [...data];
      const edsDataObj = [];
      this.data_03.forEach((a, index) => {
        const dataObj = {name: a.id, values: [a.count], colorID:  (index+2).toString()};
        edsDataObj.push(dataObj);
      });
      this.edsData02=[];
      this.edsData02 = {series: edsDataObj};
     //console.log("edsDataObj >> "+JSON.stringify(edsDataObj));
      const edsEmptyData = [{name: 'Internet explorer', values: [200], colorID: '2'}, {name: 'Cygwin', values: [120], colorID: '3'}, {name: 'Other apps', values: [80]}];
      if(this.data_03.length > 0){
        this.edsData02 = {series: edsDataObj};
      }else{
       
       
        this.edsData02 = {series: edsEmptyData};
      }  
      this.donutChartInit4();
    });
   /*  if (document.getElementById('absolute-donut')){
    document.getElementById('absolute-donut').innerHTML = '';
    } */
    
    this.subscription.push(sub);
  }

  getApplicationOverviewTab() {
    const sub = this.applicationUsageService.applicationOverviewTab$Data.subscribe(data => {
      this.sumofApplicationItems = [...data];
      this.nodataApplication = [...data];
      if(this.sumofApplicationItems.length==0){

        this.sumofApplicationItems = [{"id":"Internet Explorer","usage_hours":0,"user_count":0},{"id":"Cygwin","usage_hours":0,"user_count":0},{"id":"Git Bash","usage_hours":0,"user_count":0}]
      }
    //console.log("sumofApplicationItems jani >??  "+JSON.stringify(this.sumofApplicationItems));
    });
    this.subscription.push(sub);
  }

  getContentOverview() {
    const sub = this.contentUsageService.contentOverview$Data.subscribe(data => {
      this.data_04 = [...data];
      const edsDataObj = [];
      this.data_04.forEach((a, index) => {
        const dataObj = {name: a.id, values: [a.count], colorID: (index+2).toString()};
        edsDataObj.push(dataObj);
      });
      // edsDataObj.push({name: 'test', value: ['300'], colorID: '3'});
      this.edsData05=[];
      this.edsData05 = {series: edsDataObj};
     //console.log("edsDataObj >> "+JSON.stringify(edsDataObj));
      const edsEmptyData = [{name: 'Internet explorer', values: [200], colorID: '2'}, {name: 'Cygwin', values: [120], colorID: '3'}, {name: 'Other apps', values: [80]}];
      if(this.data_04.length > 0){
        this.edsData05 = {series: edsDataObj};
      }else{
       
       
        this.edsData05 = {series: edsEmptyData};
      }  
      this.donutChartInit5();
    });
    /* if (document.getElementById('absolute-donut2')){
    document.getElementById('absolute-donut2').innerHTML = '';
    } */
    
    this.subscription.push(sub);
  }

  getContentOverviewTab() {
    const sub = this.contentUsageService.contentOverviewTab$Data.subscribe(data => {
      this.sumofContentItems = [...data];
      if(this.sumofContentItems.length==0){

        this.sumofContentItems = [{"id":"Videos","content_count":0,"user_count":0,"launch_count":0,"complete_count":0},{"id":"Documents","content_count":0,"user_count":0,"launch_count":0,"complete_count":0},{"id":"Audio","content_count":0,"user_count":0,"launch_count":0,"complete_count":0}]
      }
     //console.log("sumofApplicationIsumofContentItemstems jani >??  "+JSON.stringify(this.sumofContentItems));
    });
    this.subscription.push(sub);
  }

  _exportToCSV() {
    //
  }

  generateCSV(section: any) {
    if (section === 'users-activity') {
      const csv = this._objectArrayToCsv(this.data_01_01);
      this._downloadFile(section, csv);
    }
    if (section === 'devices-utilization') {
      let csv = new Array();
      csv.push('Device Overview');
      csv.push('');
      csv = csv.concat(this._objectArrayToCsv(this.sumofDeviceItems));
      csv.push('');
      csv.push('User Per Device Count');
      csv.push(this.userPerDevice);
      csv.push('');
      csv.push('Tablet Utilization');
      csv.push('');
      csv = csv.concat(this._objectArrayToCsv(this.data_02_01));
      csv.push('');
      csv.push('Laptop Utilization');
      csv.push('');
      csv = csv.concat(this._objectArrayToCsv(this.data_02_02));

      this._downloadFile(section, csv);
    }
    if (section === 'application-overview') {
      let csv = new Array();
      csv.push('Application Overview');
      csv.push('');
      csv = csv.concat(this._objectArrayToCsv(this.data_03));
      csv.push('');
      csv.push('Application Usage');
      csv.push('');
      csv = csv.concat(this._objectArrayToCsv(this.sumofApplicationItems));
      csv.push('');
      this._downloadFile(section, csv);
    }
    if (section === 'content-overview') {
      let csv = new Array();
      csv.push('Learning Content Overview');
      csv.push('');
      csv = csv.concat(this._objectArrayToCsv(this.data_04));
      csv.push('');
      csv.push('Learning Content Usage');
      csv.push('');
      csv = csv.concat(this._objectArrayToCsv(this.sumofContentItems));
      csv.push('');
      this._downloadFile(section, csv);
    }
  }

  _downloadFile(section, csv) {
    const csvArray = csv.join('\r\n');
    const blob = new Blob([csvArray], {type: 'text/csv' })
    saveAs(blob, 'overview-' + section + '.csv');
  }

  _objectArrayToCsv(data: any) {
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    return csv;
  }
}
